import { render, staticRenderFns } from "./FireCrawl.vue?vue&type=template&id=3a3b2670&"
import script from "./FireCrawl.vue?vue&type=script&lang=js&"
export * from "./FireCrawl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a3b2670')) {
      api.createRecord('3a3b2670', component.options)
    } else {
      api.reload('3a3b2670', component.options)
    }
    module.hot.accept("./FireCrawl.vue?vue&type=template&id=3a3b2670&", function () {
      api.rerender('3a3b2670', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/knowledge/components/FireCrawl.vue"
export default component.exports